export enum ConstructionTypes {
  CHEMISTRY = 'chemistry',
  BANK = 'bank',
  USER = 'user',
  STORE = 'store',
  INDUSTRY = 'industry',
}
